import { createSelector } from '@reduxjs/toolkit'

import { makeTypedFetchSelectors } from 'app/redux-fetch'
import { RootState } from 'app/store'
import {
  DOMAINS_REDUCER_NAME,
  DOMAIN_DEALERS_REDUCER_NAME,
  DOMAIN_EXPORT_REDUCER_NAME,
} from 'features/domains/consts'

import type { DomainType, DomainExportType } from 'features/domains/types'
import {
  CURRENT_ROOT_ID_REDUCER_NAME,
  ROOT_DOMAINS_DATA_REDUCER_NAME,
  ROOT_DOMAINS_REDUCER_NAME,
} from './consts'

const selectRootDomains = (state: RootState) => state[ROOT_DOMAINS_REDUCER_NAME]

export const rootDomainsDataSelector = makeTypedFetchSelectors<DomainType[]>(
  ROOT_DOMAINS_REDUCER_NAME,
  ROOT_DOMAINS_DATA_REDUCER_NAME
)

export const rootDomainByIdSelector = (domainId: string | null) =>
  createSelector(
    rootDomainsDataSelector.data,
    (rootDomains): DomainType | undefined =>
      rootDomains?.find((domain) => domain.id === domainId)
  )

export const currentRootDomainIdSelector = createSelector(
  selectRootDomains,
  (state) => state[CURRENT_ROOT_ID_REDUCER_NAME]
)

export const selectDomainDealers = makeTypedFetchSelectors<DomainType[]>(
  DOMAINS_REDUCER_NAME,
  DOMAIN_DEALERS_REDUCER_NAME
)

export const selectDomainExport = makeTypedFetchSelectors<DomainExportType[]>(
  DOMAINS_REDUCER_NAME,
  DOMAIN_EXPORT_REDUCER_NAME
)


export const selectDealerByLicenseDomainId = (
  licenseDomainId: string | undefined
) =>
  createSelector(selectDomainDealers.data, (dealers) => {
    return (
      dealers &&
      dealers.find(
        (dealer: DomainType) => dealer.rootDomainId === licenseDomainId
      )
    )
  })

export const selectYouAreDistributor = createSelector(
  selectDomainDealers.data,
  (dealers) => dealers && dealers.length > 0
)

export const knownNonDirectDealersSelector = createSelector(
  rootDomainsDataSelector.data,
  (domains) =>
    domains?.filter(
      (domain) => domain?.vadDomainId || domain?.distributorDomainIds.length
    ) || []
)
